module.exports = __webpack_public_path__ + "static/img/4.a625725.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-maquinaria-equipo-contratistas/4.png
// module id = mbBk
// module chunks = 0